const activity = [
    {
        id : 'A001',
        destination_code : 'MDN',
        activity_name : 'Visit Tjong Afie',
        price : "Rp 250.000",
    },
    {
        id : 'A002',
        destination_code : 'MDN',
        activity_name : 'Visit Istana Maimun',
        price : "Rp 200.000",
    },
    {
        id : 'A003',
        destination_code : 'BKL',
        activity_name : 'Tracking',
        price : "Rp 500.000",
    },
    {
        id : 'A004',
        destination_code : 'BKL',
        activity_name : 'Rafting',
        price : "Rp 500.000",
    },
    {
        id : 'A004',
        destination_code : 'TKH',
        activity_name : 'Elephant Wash',
        price : "Rp 300.000",
    },
]

export default activity